module.exports = __webpack_public_path__ + "img/wind.03ffc02e.svg";